import { render } from "./candidate_recommend_apply.vue?vue&type=template&id=66892d38&scoped=true"
import script from "./candidate_recommend_apply.vue?vue&type=script&lang=js"
export * from "./candidate_recommend_apply.vue?vue&type=script&lang=js"

import "./candidate_recommend_apply.vue?vue&type=style&index=0&id=66892d38&lang=scss&scoped=true"

import exportComponent from "F:\\workspace\\custom\\sdxlxh\\ShanDongXinLiZiXun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66892d38"]])

export default __exports__